(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;

  var selector = 'main .fmt-h2,main .fmt-workbench article,main .fmt-loc,main .fmt-journal-card,main [data-fmt-reveal],main .archive-section h2,main .archive-media,main .archive-timeline li,main .archive-voice,main .archive-care__item,main .fmt-phero__photo';
  var active = new Map();
  function settle(el) {
    el.classList.remove('fmt-motion-pending');
    observer.unobserve(el);
    var animation = active.get(el);
    if (animation) { active.delete(el); animation.cancel(); }
  }
  var observer = new IntersectionObserver(function (entries) {
    var rowTop = null, rowIndex = 0;
    entries.filter(function (entry) { return entry.isIntersecting; })
      .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left; })
      .forEach(function (entry) {
        var el = entry.target, rect = entry.boundingClientRect;
        observer.unobserve(el);
        if (reduceMotion.matches || rect.bottom <= 0 || el.contains(document.activeElement)) { settle(el); return; }
        // Only stagger neighbours in the same row, never unrelated sections.
        if (rowTop === null || Math.abs(rect.top - rowTop) > 48) { rowTop = rect.top; rowIndex = 0; }
        var distance = window.innerWidth < 750 ? 12 : 18;
        try {
          var animation = el.animate([
            { transform: 'translateY(' + distance + 'px)', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ], { duration: 1150, delay: Math.min(rowIndex++, 2) * 90, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'both' });
          active.set(el, animation);
          el.classList.remove('fmt-motion-pending');
          animation.onfinish = function () { settle(el); };
        } catch (error) { settle(el); }
      });
  }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });

  function init() {
    if (reduceMotion.matches) return;
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.warmMotion) return;
      el.dataset.warmMotion = 'true';
      // Leave the first screen and restored scroll positions stable. Do not
      // animate a heading separately from an already animated parent card.
      if (el.parentElement.closest(selector) || el.closest('.scroll-trigger') || el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('fmt-motion-pending');
      observer.observe(el);
    });
  }
  function settleAll() {
    document.querySelectorAll('.fmt-motion-pending').forEach(settle);
    active.forEach(function (animation, el) { settle(el); });
  }
  // Keyboard focus and in-page links must never land on invisible content.
  document.addEventListener('focusin', function (event) {
    var el = event.target.closest('[data-warm-motion]');
    if (el) settle(el);
  });
  window.addEventListener('hashchange', settleAll);
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', function () { if (reduceMotion.matches) settleAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
